// extracted by mini-css-extract-plugin
module.exports = {"select":"AccessCategorySelector_select__2STkK","option":"AccessCategorySelector_option__3GS4Q"};